import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './responsive-grid.scss.js';

class ResponsiveGrid extends s {
    constructor() {
        super(...arguments);
        this.additionalClasses = '';
    }
    render() {
        return x `<div class="responsive-grid ${this.additionalClasses}"><slot></slot></div>`;
    }
}
ResponsiveGrid.styles = css_248z;
__decorate([
    n({ type: String })
], ResponsiveGrid.prototype, "additionalClasses", void 0);
customElements.define('responsive-grid', ResponsiveGrid);

export { ResponsiveGrid };
